/*-- MENÚ MÓVIL --*/

$('#cl_btn_open').click(function() {
    mostrar_menu(1);
});

$('.btn_cerrar_menu, .cl_fondo_menu').click(function() {
    mostrar_menu(0);
});

$('.cl_desplaza_menu').click(function() {
    desplaza_menu($(this).data('menuval1'),$(this).data('menuval2'));
});

window.mostrar_menu = function(i){

    if(i == 0){
        $("body").removeClass("cl-menu-movil-open");
    }else if(i == 1){
        $("body").addClass("cl-menu-movil-open")
    }

    $('#cl_btn_open, #navbar_menu, .btn_cerrar_menu, .cl_fondo_menu').addClass('cl-pointer-events');

    let myWidth = get_browser_width();

    if(i == 1){

        if(myWidth > 650){
            $('#cl_nav').show();
            $('#cl_nav nav').animate({left: '0px'}, 250);
            $('.cl_fondo_menu').animate({opacity: '1'}, 500, function() {
                $('#cl_btn_open, #navbar_menu, .btn_cerrar_menu, .cl_fondo_menu').removeClass('cl-pointer-events');
            });
        }else{
            $('#cl_nav').show();
            $('#cl_nav nav').animate({left: '0px'}, 250);
            $('.cl_fondo_menu').animate({opacity: '1'}, 500, function() {
                $('#cl_btn_open, #navbar_menu, .btn_cerrar_menu, .cl_fondo_menu').removeClass('cl-pointer-events');
            });

            var ancho_menu = $("#cl_nav nav").width();
            $('#paneles_menu').css('width',ancho_menu*3);
            $('.panel_menu').css('width',ancho_menu);
        }

    }else{

        if(myWidth > 650){
            $('#cl_nav nav').animate({left: '-400px'}, 250);
            $('.cl_fondo_menu').animate({opacity: '0'}, 500, function() {
                $('#cl_nav').hide();
                desplaza_menu(0);
                $('#cl_btn_open, #navbar_menu, .btn_cerrar_menu, .cl_fondo_menu').removeClass('cl-pointer-events');
            });
        }else{

            $('#cl_nav nav').animate({left: myWidth*-1}, 250);
            $('.cl_fondo_menu').animate({opacity: '0'}, 500, function() {
                $('#cl_nav').hide();
                desplaza_menu(0);
                $('#cl_btn_open, #navbar_menu, .btn_cerrar_menu, .cl_fondo_menu').removeClass('cl-pointer-events');
            });

        }

    }

    var alto_menu = $(".cl-menu-movil nav").outerHeight();
    var alto_ctn_logo = $(".cl-menu-movil .cl-ctn-logo").outerHeight();
    var alto_ctn_sel_idiomas = $(".cl-menu-movil .cl-ctn-sel-idiomas").outerHeight();
    var alto_ctn_scroll = alto_menu - alto_ctn_logo - alto_ctn_sel_idiomas;

    $('.cl-overflow-scroll').each(function(index,element) {
        $(this).css('height', alto_ctn_scroll);
    });

}

window.desplaza_menu = function(pos,id_panel){

    let myWidth = get_browser_width();
    var ancho_menu = $("#cl_nav nav").width();

    if(pos == 0){

        $('#panel_principal').animate({ scrollTop: 0 }, 1);
        $('#paneles_menu').animate({left: '0px'}, 250);

    }else if(pos == 1){

        $(".btn_panel1").hide();
        $("#"+id_panel).animate({ scrollTop: 0 }, 1);
        $("#"+id_panel).show();

        if(myWidth > 650){
            $('#paneles_menu').animate({left: '-400px'}, 250);
        }else{
            $('#paneles_menu').animate({left: ancho_menu*-1}, 250);
        }

    }else if(pos == 2){

        $(".btn_panel2").hide();
        $("#"+id_panel).animate({ scrollTop: 0 }, 1);
        $("#"+id_panel).show();

        if(myWidth > 650){
            $('#paneles_menu').animate({left: '-800px'}, 250);
        }else{
            $('#paneles_menu').animate({left: ancho_menu*-2}, 250);
        }

    }

}

/*-- FIN MENÚ MÓVIL --*/

// navbar
window.showNavbarDropdownMenu = function(id){
    var menus = ["menu-esqui", "menu-pistas", "menu-balnearios", "menu-parques", "menu-aventuras", "menu-hoteles", "menu-grupos"];

    for (var i = 0; i < menus.length; i++) {
        if (menus[i] == id) {
            $('#'+id).removeClass('d-none')
        } else {
            $('#'+menus[i]).addClass('d-none');
        }
    }
}

$(document).ready(function() {

    if($(".dropdown-main-menu-navbar").length) {

        $(".dropdown-main-menu-navbar").find('li[data-value]').each(function(index,element) {
            $(element).hover(
                function() {
                    $('svg[data-active=true]').removeAttr('data-active');
                    $('.rotate-180').removeClass('rotate-180');
                    showNavbarDropdownMenu($(this).attr('data-value'));
                    $(this).find('svg').addClass('rotate-180').attr('data-active', true);
                    $('div[data-name="dropdown-main-navbar"]').removeClass('d-none');
              }, function() {
                    $(this).find('svg').removeClass('rotate-180');
                    $('div[data-name="dropdown-main-navbar"]').addClass('d-none');
              }
            );
        });


        $('[data-name="dropdown-main-navbar"]').hover(
          function() {
            $('svg[data-active=true]').addClass('rotate-180');
            $('div[data-name="dropdown-main-navbar"]').removeClass('d-none');

          }, function() {
            $('.rotate-180').removeClass('rotate-180');
            $('svg[data-active=true]').removeAttr('data-active');
            $('div[data-name="dropdown-main-navbar"]').addClass('d-none');
          }
        );

        $('#navbar_menu').click(function() {
            mostrar_menu(1)
        });
    }

    //IDIOMAS
    if($(".cl-ctn-idiomas.cl-login-ok,#panel_idiomas.cl-login-ok").length > 0){
                    
        $(".cl-ctn-idiomas.cl-login-ok .dropdown-menu li a,#panel_idiomas.cl-login-ok a").click(function() {
            
            $("#changeLang input[id='idioma']").val($(this).data('lang'));
            
            if($("#changeLang input[id='idioma']").val() != ''){
                $("#changeLang").submit();
            }

        });
    
    }

});
// end navbar